import React from 'react';
import { Badge } from '../ui/badge';
import { ShieldCheck, ShieldAlert, ShieldQuestion } from 'lucide-react';

const LEVEL_CONFIG = {
  high: {
    icon: ShieldCheck,
    label: 'High',
    variant: 'default',
    className: 'bg-green-100 text-green-800 border-green-200 hover:bg-green-100',
  },
  medium: {
    icon: ShieldAlert,
    label: 'Medium',
    variant: 'default',
    className: 'bg-amber-100 text-amber-800 border-amber-200 hover:bg-amber-100',
  },
  low: {
    icon: ShieldQuestion,
    label: 'Low',
    variant: 'default',
    className: 'bg-red-100 text-red-800 border-red-200 hover:bg-red-100',
  },
};

export default function FieldConfidenceBadge({ level, score }) {
  const config = LEVEL_CONFIG[level] || LEVEL_CONFIG.low;
  const Icon = config.icon;

  return (
    <Badge
      variant="outline"
      className={`flex items-center gap-1 text-xs ${config.className}`}
      data-testid={`confidence-badge-${level}`}
    >
      <Icon className="h-3 w-3" />
      {config.label}
      {typeof score === 'number' && (
        <span className="ml-0.5 opacity-70">{score}%</span>
      )}
    </Badge>
  );
}
